module.exports = __webpack_public_path__ + "img/timelineStatistics.02f26b74.svg";